<div class="mt-24">
  <div class="filter">
    <div class="grid grid--va-bottom">
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>Функция</label>
          <app-combobox
            [items]="functions"
            (callback)="onChangeSelectedFunction($event)"
            [textKey]="'service_function_name'"
            [defaultText]="'Выберите функцию'"
            [initBy]="functionSelected"
            [isDisabled]="!functions || !functions.length"
            [name]="'serviceFunctionId'"
          ></app-combobox>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="grid grid--va-middle">
          <div class="grid__box grid__box--size-min">
            <button class="button" id="appApplyFilterServiceFunction" type="button" (click)="onApplyFilter()" [disabled]="!isDisabledApplyFilterButton">Применить</button>
          </div>
          <div class="grid__box grid__box--size-min">
            <a class="link link--dotted-blue-dark" id="appResetFilterServiceFunction" (click)="onResetFilter()">Сбросить</a>
          </div>
          <div class="grid__box grid__box--size-min">
            <div class="pl-24 mr-2">
              <app-checkbox>
                <input type="checkbox" id="appShowDisabledServiceFunction" [checked]="isShowDisabled" (change)="onChangeVisibleHiddenServiceFunctions.emit($event)" />
                <checkbox-text>Показать отключенные</checkbox-text>
              </app-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
